module.exports = __webpack_public_path__ + "img/ss_gtax-tob.6db3ab3.jpg";